
const m = window.require("@ember/instrumentation");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
